import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { api } from '../lib/api.js';
import { useStore } from '../state/store.js';

export function LoginScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useStore((s) => s.toast);
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const inputRef = useRef();

  useEffect(() => {
    // Already logged in? bounce to /episodes
    api.authStatus().then((r) => {
      if (r.authenticated) navigate(location.state?.from || '/episodes', { replace: true });
    }).catch(() => {});
    setTimeout(() => inputRef.current?.focus(), 100);
  }, [navigate, location.state]);

  const submit = async (e) => {
    e.preventDefault();
    if (!password) return;
    setBusy(true);
    setErr('');
    try {
      await api.login(password);
      toast('добро пожаловать', 'ok');
      navigate(location.state?.from || '/episodes', { replace: true });
    } catch (e) {
      setErr(e.message || 'не удалось войти');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-mark">
          <svg viewBox="0 0 32 32" width="42" height="42" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round">
            <circle cx="10" cy="16" r="6" />
            <circle cx="22" cy="16" r="6" />
          </svg>
        </div>

        <h1 className="login-title serif">Editor Dos Mundos</h1>
        <div className="login-eyebrow">Dos Mundos · Reels CMS</div>

        <p className="login-desc">
          Нарезает короткие 9:16 Instagram Reels из недельных трансляций маэстро Пепе на Facebook.
          Загружаешь видео или вставляешь ссылку на FB‑эфир — Editor Dos Mundos скачивает поток,
          распознаёт испанскую речь через AssemblyAI, DeepSeek разбивает на главы и
          ключевые инсайты ~1 мин, ты правишь субтитры и текст поста, рендер уходит на
          сервер и публикуется в Instagram через VNC.
        </p>

        <form onSubmit={submit} className="login-form">
          <label className="login-field">
            <span className="login-label">пароль</span>
            <input
              ref={inputRef}
              type="password"
              className="login-input"
              autoComplete="current-password"
              value={password}
              onChange={(e) => { setPassword(e.target.value); setErr(''); }}
              disabled={busy}
              placeholder="•••••••••"
            />
          </label>

          {err && <div className="login-error">⚠ {err}</div>}

          <button type="submit" className="btn btn-publish btn-full login-btn" disabled={busy || !password}>
            {busy ? <><span className="spinner" /> входим…</> : 'войти'}
          </button>
        </form>

        <div className="login-footer">
          <span className="muted small">
            editor.dosmundos.pe · доступ только по паролю
          </span>
        </div>
      </div>

      <div className="login-bg" aria-hidden>
        <div className="login-bg-blob login-bg-blob-1" />
        <div className="login-bg-blob login-bg-blob-2" />
      </div>
    </div>
  );
}
